module.exports = __webpack_public_path__ + "static/media/cigarettes_02_thumb_hover.3076e476.png";